module.exports = {"VUE_APP_ENVIRONMENT":"DEVELOPMENT/TEST","VUE_APP_PHP_API_BASE_PATH":"https://poh-api-test.adv-ant.ru/v1/","VUE_APP_DOTNET_API_BASE_PATH":"https://services.adv-ant.ru/api-test/","VUE_APP_OTP_SERVICE_BASE_PATH":"https://demo.mfa.adv-ant.ru/v1/api/","VUE_APP_LA_API_BASE_PATH":"https://demo.loganalyzerapi.adv-ant.ru/v1/api/logs","VUE_APP_USERSTATUS_API_BASE_PATH":"https://demo.userstatusapi.adv-ant.ru/v1/api/"}


//////////////////
// WEBPACK FOOTER
// ./static/data/appconfig.dev.json
// module id = Ycef
// module chunks = 1